module.exports = __webpack_public_path__ + "static/img/xyqp-01.3e9f3a53.jpg";